const audioFormats = {
	MP3: "mp3",
	WAV: "wav",
	RAW: "raw",
	// AAC: "aac",
};

export default audioFormats;
